<template>
    <v-container class="pt-0 pb-5">
        <v-row>
            <v-col>
                <div class="d-flex flex-column ga-2 pa-2 rounded elevation-1 bg-white">
                    <div>
                        <SportipsButton toPage="Administration" chevronLeft>Retour</SportipsButton>
                    </div>
                    <div class="text-h5 font-weight-bold">Administration des retraits de dossard</div>
                    <div>Cette interface vous permet de suivre les créneaux de retrait de dossard pour les courses de {{
                        mainStore.module.nom }}.</div>
                </div>
            </v-col>
        </v-row>
        <v-row class="mt-2">
            <v-col cols="12">
                <CreneauxRetraitDossardList ref="creneauxList" />
            </v-col>
            <v-col cols="12">
                <CreneauRetraitDossardCreateForm @created="onCreneauCreated" />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import CreneauxRetraitDossardList from "@/components/Administration/RetraitDossard/CreneauxRetraitDossardList.vue";
import CreneauRetraitDossardCreateForm from "@/components/Administration/RetraitDossard/CreneauRetraitDossardCreateForm.vue";

export default {
    components: {
        CreneauxRetraitDossardList,
        CreneauRetraitDossardCreateForm,
    },
    computed: {
        ...mapStores(useMainStore),
    },
    methods: {
        onCreneauCreated() {
            this.$refs.creneauxList?.refresh?.();
        },
    },
};
</script>

<style lang="scss" scoped></style>
